import React from 'react';
import { connect } from 'react-redux';
import { BaseStore } from 'src/store';

import { LayoutDynamicZone } from 'src/modules/layout';
import LayoutPage from 'src/modules/layout/components/page/LayoutPage';
import { useIntl } from 'react-intl';
import { PagesStore, PageEntity, PageKeys } from 'src/modules/pages';
import { useLocale } from 'src/modules/locale';

interface PagesSalesProps extends PagesStore {
  page?: PageEntity;
}

const PagesSales: React.FunctionComponent<PagesSalesProps> = (props) => {
  const intl = useIntl();
  const { getLocalizedObject } = useLocale();

  const pageProperties = {
    title: intl.formatMessage({ id: 'page/sales/head/page_title' }),
    description: intl.formatMessage({ id: 'page/sales/head/meta_description' }),

    breadcrumbs: [
      {
        title: intl.formatMessage({
          id: 'breadcrumbs/professionals',
        }),
        as: '/professionals',
        href: '/professionals',
      },
      {
        title: intl.formatMessage({
          id: 'breadcrumbs/professionals/sales',
        }),
        as: '/professionals/contact',
        href: '/professionals/contact',
      },
    ],
  };

  const { dynamic_content } = getLocalizedObject(props).page || {};
  return (
    <LayoutPage {...pageProperties}>
      {dynamic_content && <LayoutDynamicZone components={dynamic_content} />}
    </LayoutPage>
  );
};

const mapStateToProps = (state: BaseStore) => {
  return {
    page: state.pages.pages[PageKeys.Sales],
    ...state.pages,
  };
};
export default connect(mapStateToProps)(PagesSales);
